export default __webpack_public_path__ + "static/media/royal_bow.06fbac8b.png";